import { mapGetters } from 'vuex'

const mixin = {
  computed: {
    ...mapGetters('offersDestinations', ['hotDestinations']),
    availableCities() {
      return this.hotDestinations.filter(city => {
        const amount = city?.priceFrom?.amount
        return amount !== 0
      })
    }
  }
}

export default mixin
